import { MuiComponentOverrides } from "."
import spacing from "theme/themeSpacing"
import theme from "theme/themePalette"

export const MuiAccordionOverrides: MuiComponentOverrides<'MuiAccordion', 'MuiAccordion'> = {
  defaultProps: {
    disableGutters: true,

  },
  styleOverrides: {
    root: {
      border: `2px solid ${theme.palette.divider}`,
      padding: `0 ${spacing.md}`,
      boxShadow: 'none',
      '&:not(:last-child)': {
        borderBottom: 0,
      },
      '&:before': {
        display: 'none',
      },
    }
  }
}